import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: "50%", cy: "50%", r: 3, fill: "currentColor", stroke: "none" }));
export default SvgDot;
